// InvoiceAPI.ts
import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class InvoiceAPI {
	async getInvoices(query: any) {
		return xget<PGSchema.invoice[]>("/admin/invoices", query);
	}

	async createInvoice(invoiceData: Partial<PGSchema.invoice>) {
		return xhttp<PGSchema.invoice>("/admin/invoices", "POST", invoiceData);
	}

	async getInvoice(id: number) {
		return xget<PGSchema.invoice>(`/admin/invoices/${id}`);
	}

	async updateInvoice(id: number | bigint, invoiceData: Partial<PGSchema.invoice>) {
		return xhttp<PGSchema.invoice>(`/admin/invoices/${id}`, "PUT", invoiceData);
	}

	async deleteInvoice(id: number | bigint) {
		return xhttp<PGSchema.invoice>(`/admin/invoices/${id}`, "DELETE", {});
	}
}
